import React, { useEffect, useRef, useState } from "react";
import { Callout, Card, H2, Tag } from "@blueprintjs/core";
import { Trans, withTranslation } from "react-i18next";
//import { w3cwebsocket as W3CWebSocket } from "websocket";

import Title from "../Structure/logo";
import {
  authenticatedGetFetch,
  authenticatedGetFetchWithoutLoginRedirection,
  getBackendRoute,
} from "../../utils/AuthenticatedFetch";
import { useNavigate } from "react-router-dom";
import i18n from "../../i18n";
import { Counter } from "./Counters";
import withRouter from "../Structure/withRouter";
import { w3cwebsocket } from "websocket";

export function cachedGroups(force_update = false) {
  if (localStorage.getItem("groups") == null || force_update === true) {
    return new Promise((res, rej) => {
      authenticatedGetFetchWithoutLoginRedirection(
        "/supervision/groups",
        (response) => {
          const groups = response.reduce((a, g) => ({ ...a, [g.id]: g }), {});
          localStorage.setItem("groups", JSON.stringify(groups));
          res(groups);
        },
        null,
        () => {
          res({});
        }
      );
    });
  } else return JSON.parse(localStorage.getItem("groups"));
}

function GroupCard(props) {
  const navigate = useNavigate();
  const [devices, setDevices] = useState([0, 0, 0, 0]);
  const [parks, setParks] = useState({ working: 0, full: 0, closed: 0 });
  const [mainCounter, setMainCounter] = useState();
  let wsClient = useRef(null);

  useEffect(() => {
    authenticatedGetFetch(
      `/supervision/group/${props.id}/state`,
      (response) => {
        setDevices(response.devices);
        setParks(response.parks);
        setMainCounter(response.mainCounter);
        // setCounter(response.counter); // display only main counter on this menu
        // open and handle websocket
        wsClient.current = new w3cwebsocket(
          `${getBackendRoute("WS")}/supervision/group/${props.id}/state`,
          ["Bearer", localStorage.getItem("token")]
        );

        wsClient.current.onopen = () => {
          console.log("WebSocket Client for supervision menu connected");
        };

        wsClient.current.onmessage = (message) => {
          try {
            const response = JSON.parse(message.data);
            setDevices(response.devices);
            setParks(response.parks);
          } catch (e) {
            console.error(
              "invalid group state received from rt:",
              message.data,
              e
            );
          }
        };
      }
    );
    return () => {
      if (wsClient.current) {
        wsClient.current.close();
        console.log("WebSocket Client for supervision menu connected");
      }
    };
  }, [props.id]);

  return (
    <div className="card">
      <Card
        interactive={true}
        onClick={() => navigate("/supervision/" + props.id)}
        style={{ flexGrow: 1, flexShrink: 1, flexBasis: 1 /* , width:0 */ }}
      >
        <H2>{props.label}</H2>
        {devices && (
          <Callout
            title={<Trans>equipments</Trans>}
            style={{ visibility: devices === undefined ? "hidden" : "normal" }}
          >
            <Tag style={{ visibility: "hidden" }} />{" "}
            {/* not diaplayed, used to have same size if no device to display */}
            {devices[1] > 0 && (
              <Tag intent="danger">
                {devices[1]} <Trans>state2</Trans>
              </Tag>
            )}{" "}
            {/* defaut */}
            {devices[2] > 0 && (
              <Tag intent="warning">
                {devices[2]} <Trans>state1</Trans>
              </Tag>
            )}{" "}
            {/* KO */}
            {devices[0] > 0 && (
              <Tag intent="success">
                {devices[0]} <Trans>state0</Trans>
              </Tag>
            )}{" "}
            {/* OK */}
            {devices[3] > 0 && (
              <Tag>
                {devices[3]} <Trans>state3</Trans>
              </Tag>
            )}{" "}
            {/* disconnected */}
          </Callout>
        )}

        <Callout
          title={<Trans>parks</Trans>}
          style={{ visibility: parks === undefined ? "hidden" : "normal" }}
        >
          <Tag style={{ visibility: "hidden" }} />{" "}
          {/* not diaplayed, used to have same size if no park to display */}
          {parks?.closed > 0 && (
            <Tag intent="danger">
              {parks["closed"]} <Trans>closed</Trans>
            </Tag>
          )}{" "}
          {parks?.full > 0 && (
            <Tag intent="warning">
              {parks["full"]} <Trans>full</Trans>
            </Tag>
          )}{" "}
          {parks?.working > 0 && (
            <Tag intent="success">
              {parks["working"]} <Trans>working</Trans>
            </Tag>
          )}{" "}
        </Callout>

        {mainCounter && (
          <Counter {...mainCounter} editable={false} standalone={true} />
        )}
      </Card>
    </div>
  );
}

class SupervisionMenu extends React.Component {
  constructor() {
    super();
    this.state = {
      groups: {},
    };
  }

  componentDidMount() {
    this.setState({ groups: { ...this.state.groups, ...cachedGroups() } });
  }

  render() {
    const groups = [];
    for (const groupId in this.state.groups) {
      if (this.state.groups[groupId].display)
        groups.push(
          <GroupCard key={"group" + groupId} {...this.state.groups[groupId]} />
        );
    }
    if (groups.length === 0) {
      const { navigate } = this.props;
      navigate("/supervision/0");
    }
    return (
      <div className="component-body">
        <Title icon="drive-time" text="Supervision" />
        <div className="flexbox-center">
          <GroupCard id={0} label={i18n.t("global view")} />
        </div>
        <div className="cards">{groups}</div>
      </div>
    );
  }
}

export default withTranslation()(withRouter(SupervisionMenu));
